import { gsap } from "gsap";

(function (Drupal) {

  Drupal.behaviors.tabsAutoplay = {
    attach(context) {

      const wrapper = context.querySelector('.js-tabs-autoplay');
      if (!wrapper || wrapper.dataset.autoplayInit) return;
      wrapper.dataset.autoplayInit = 'true';

      const tabs = wrapper.querySelectorAll('[data-bs-toggle="tab"]');
      const content = wrapper.querySelector('.tab-content');

      if (tabs.length < 2) return;

      let index = 0;
      let tween;

      const resetBars = () => {
        gsap.set(wrapper.querySelectorAll('.tab-progress-bar'), {
          width: "0%"
        });
      };

      const animateProgress = (tab) => {

        const bar = tab.querySelector('.tab-progress-bar');

        tween = gsap.to(bar, {
          width: "100%",
          duration: 3,
          ease: "linear",
          onComplete: () => {
            index = (index + 1) % tabs.length;
            tabs[index].click();
          }
        });
      };

      const start = () => {

        index = 0;
        tabs[index].click();

        resetBars();
        animateProgress(tabs[index]);

      };

      const pause = () => {
        if (tween) tween.pause();
      };

      const resume = () => {
        if (tween) tween.resume();
      };

      const stop = () => {
        if (tween) {
          tween.kill();
          tween = null;
        }

        index = 0;

        gsap.set(wrapper.querySelectorAll('.tab-progress-bar'), {
          width: "0%"
        });
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('shown.bs.tab', () => {

          index = i;

          if (tween) tween.kill();

          resetBars();
          animateProgress(tab);

        });
      });

      // Hover SOLO en contenido
      if (content) {
        content.addEventListener('mouseenter', pause);
        content.addEventListener('mouseleave', resume);
      }

      // Intersection Observer (cuando entra en viewport)
      const observer = new IntersectionObserver((entries) => {

        entries.forEach(entry => {

          if (entry.isIntersecting) {
            start();
          }

        });

      }, {
        threshold: 0.4
      });

      observer.observe(wrapper);

    }
  };

})(Drupal);